import { useUploadState, FileUploadStatus, retryUpload, canceledUpload, hideUploadsDrawer } from "@/logic/files";
import { Button } from "../Button";
import { closeIcon } from "@roc-digital/ui-lib";
import { Icon } from "../Icon";
import React from "react";

export function useUploadsDrawer() {
  
}

export function UploadsDrawer() {
  const {showDrawer, uploads} = useUploadState();
  const [open, setOpen] = React.useState(false);

  if(!uploads.length || !showDrawer) return null;

  return <div style={{position: 'fixed', bottom: '0px', right: '120px', display: 'flex', flexDirection: 'column', width: '300px', boxShadow: '0px 0px 2px #24aae1'}}>
    <div className="flex flex-row items-center bg-[#24aae1] text-[white] font-bold h-10 p-4 cursor-pointer" onClick={() => setOpen(o => !o)}>
      Uploads {uploads.length ? `(${uploads.length})` : ''}
      <span className="flex-grow"></span>
      <Icon className="" src={closeIcon} clickEvent={hideUploadsDrawer} fill="white" circleColor="white" circle circleSize="x-small" invert/>
    </div>
    <div style={{maxHeight: open ? '300px' : '0px', height: '300px', backgroundColor: '#d9d9d9', gap: 1, overflowY: 'auto', width: '300px', overflowX: 'hidden'}} className="flex flex-col">
      {uploads.map(upload => <UploadItem upload={upload} key={upload.id}/>)}
      <div className="flex-grow bg-white"></div>
    </div>
  </div>
}

function UploadItem(props: {upload: FileUploadStatus}) {
  return <div className="px-2 flex gap-2 items-center h-8 w-full bg-white">
    <span className="flex-grow" style={{
      textOverflow: 'ellipsis',
      lineBreak: 'loose',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    }}>{props.upload.file.name}</span>
    <span style={{fontSize: '12px', color: '#8d8d8d', textTransform: 'capitalize'}}>{props.upload.status}</span>
    {props.upload.status === 'queued' ? <Icon className="" src={closeIcon} clickEvent={() => canceledUpload(props.upload.id)} /> : null}
    {props.upload.status === 'error' || props.upload.status === 'canceled' ? 
      <Button variant="white" size="sm" clickEvent={() => retryUpload(props.upload.id)}>Retry</Button>
    : null}
  </div>
}